import React, { type ReactElement } from 'react';
import { ChevronDown, Notebook } from 'lucide-react';

interface PatientNotesOverlayProps {
  notes: string;
  isExpanded: boolean;
  onToggleExpand: () => void;
}

export function PatientNotesOverlay({
  notes,
  isExpanded,
  onToggleExpand,
}: PatientNotesOverlayProps): ReactElement | null {
  if (!isExpanded) {
    return (
      <button
        onClick={onToggleExpand}
        aria-label='Notizen ausklappen'
        style={{
          position: 'absolute',
          bottom: '1rem',
          left: '1rem',
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          backgroundColor: 'rgba(40, 40, 40, 0.8)',
          backdropFilter: 'blur(5px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          zIndex: 10,
          color: 'white',
          boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
        }}
      >
        <Notebook size={24} />
      </button>
    );
  }

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '1rem',
        left: '1rem',
        width: '350px',
        maxWidth: '90%',
        maxHeight: '40%',
        overflow: 'hidden',
        backgroundColor: 'rgba(40, 40, 40, 0.8)',
        backdropFilter: 'blur(5px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        zIndex: 10,
        boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        onClick={onToggleExpand}
        aria-label='Notizen einklappen'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '1rem',
          borderBottom: '1px solid rgba(255,255,255,0.2)',
          flexShrink: 0,
          cursor: 'pointer',
        }}
      >
        <h4 style={{ margin: 0 }}>Patient möchte besprechen</h4>
      </div>
      <div style={{ padding: '0 1rem 1rem 1rem', overflowY: 'auto', whiteSpace: 'pre-wrap' }}>
        {notes ? (
          <p
            style={{
              marginTop: '0.75rem',
              fontSize: '1.125rem',
            }}
          >
            {notes}
          </p>
        ) : (
          <p
            style={{
              marginTop: '0.75rem',
              fontSize: '1.125rem',
              fontStyle: 'italic',
              color: 'rgba(255, 255, 255, 0.7)',
            }}
          >
            Keine Notizen vorhanden.
          </p>
        )}
      </div>
    </div>
  );
}
